module.exports = "<p>imovel-outras-entidades works!</p>\r\n"